<template>
    <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="textModel"
            persistent
            width="290px"
    >
        <template v-slot:activator="{ on }">
            <div class="columns">
                <div class="column is-narrow">
                    <label class="label" style="margin-top: 22px;display: inline-block;">{{label}}</label>&nbsp;
                </div>
                <div class="column">
                    <v-text-field
                            :label="textLabel"
                            v-model="textModel"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                    ></v-text-field>
                </div>
            </div>
        </template>
        <v-date-picker v-model="textModel" scrollable>
            <div class="flex-grow-1"></div>
            <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
            <v-btn text color="primary" @click="$refs.dialog.save(textModel)">OK</v-btn>
        </v-date-picker>
    </v-dialog>
</template>
<script>
    export default {
        name: 'DialogDatePicker',
        props: ['textLabel', 'value', 'label'],
        data() {
            return {
                textModel: null,
                modal: false,
            }
        },
        watch: {
          textModel() {
              this.$emit('input', this.textModel)
          }
        },
        mounted() {
          this.textModel = this.value;
        },
        methods: {
        }
    }
</script>